/* NOTE: This file is generated by our build script, do not manually edit */
const deprecatedTokens = [
  'space.insetSquish.x1',
  'space.insetSquish.x2',
  'space.insetSquish.x3',
  'space.insetSquish.x4',
  'space.insetSquish.x5',
  'space.insetSquish.x6',
];
const rawTokens = [
  'colors.palette.gray.gray97',
  'colors.palette.gray.gray91',
  'colors.palette.gray.gray84',
  'colors.palette.gray.gray53',
  'colors.palette.gray.gray40',
  'colors.palette.gray.gray20',
  'colors.palette.red.red40',
  'colors.palette.red.red33',
  'colors.palette.red.red24',
  'colors.palette.orange.orange45',
  'colors.palette.orange.orange36',
  'colors.palette.green.green37',
  'colors.palette.green.green32',
  'colors.palette.green.green26',
  'colors.palette.green.green20',
  'colors.palette.green.green13',
  'colors.palette.blue.blue53',
  'colors.palette.purple.purple32',
  'colors.palette.yellow.yellow52',
  'colors.palette.taupe.taupe73',
  'colors.palette.taupe.taupe90',
  'colors.palette.gold.gold67',
  'colors.palette.ivory.ivory84',
  'colors.palette.olive.olive66',
  'colors.palette.teal.teal76',
  'colors.palette.teal.teal81',
  'colors.palette.teal.teal95',
  'colors.palette.coral.coral72',
  'colors.palette.red.red22',
  'colors.palette.green.green47',
  'colors.palette.purple.purple37',
  'colors.palette.purple.purple15',
  'colors.palette.yellow.yellow50',
  'colors.palette.gold.gold50',
  'colors.palette.teal.teal27',
  'colors.palette.lime.lime70',
  'colors.palette.oatmeal.oatmeal',
  'colors.circle.brand.primary',
  'colors.circle.brand.secondary',
  'colors.circle.background.primary',
  'colors.circle.background.secondary',
  'colors.circle.text.primary',
  'colors.circle.text.secondary',
  'colors.shipt.brand.green',
  'colors.shipt.brand.purple',
  'colors.shipt.teal',
  'colors.shipt.lime',
  'colors.shipt.purple',
  'colors.shipt.gold',
  'colors.shipt.oatmeal',
];
module.exports = {
  utils: {
    isDeprecated: function(token) {
      return deprecatedTokens.includes(token);
    },
    isRaw: function(token) {
      return rawTokens.includes(token);
    },
  },
  border: {
    radius: {
      default: '4px',
      x1: '4px',
      x2: '8px',
      x3: '12px',
      x4: '16px',
      x5: '20px',
      x6: '24px',
      circle: '100%',
      top: {
        x1: '4px 4px 0 0',
        x2: '8px 8px 0 0',
        x3: '12px 12px 0 0',
        x4: '16px 16px 0 0',
        x5: '20px 20px 0 0',
        x6: '24px 24px 0 0',
      },
      right: {
        x1: '0 4px 4px 0',
        x2: '0 8px 8px 0',
        x3: '0 12px 12px 0',
        x4: '0 16px 16px 0',
        x5: '0 20px 20px 0',
        x6: '0 24px 24px 0',
      },
      bottom: {
        x1: '0 0 4px 4px',
        x2: '0 0 8px 8px',
        x3: '0 0 12px 12px',
        x4: '0 0 16px 16px',
        x5: '0 0 20px 20px',
        x6: '0 0 24px 24px',
      },
      left: {
        x1: '4px 0 4px 0',
        x2: '8px 0 8px 0',
        x3: '12px 0 12px 0',
        x4: '16px 0 16px 0',
        x5: '20px 0 20px 0',
        x6: '24px 0 24px 0',
      },
    },
  },
  breakpoints: {
    xxsMax: '374px',
    xs: '375px',
    xsMax: '479px',
    sm: '480px',
    smMax: '667px',
    md: '668px',
    mdMax: '991px',
    lg: '992px',
    lgMax: '1199px',
    xl: '1200px',
  },
  colors: {
    palette: {
      white: '#fff',
      black: '#000',
      gray: {
        gray97: '#f7f7f7',
        gray91: '#e8e8e8',
        gray84: '#d6d6d6',
        gray53: '#888',
        gray40: '#666',
        gray20: '#333',
        lightest: '#f7f7f7',
        light: '#d6d6d6',
        medium: '#888',
        dark: '#666',
        darkest: '#333',
      },
      red: {
        red40: '#c00',
        red33: '#a00',
        red24: '#790000',
        red22: '#720000',
        default: '#c00',
        dark: '#a00',
      },
      orange: {
        orange45: '#E86900',
        orange36: '#b85300',
        default: '#E86900',
        dark: '#b85300',
        light: '#FFF5EB',
      },
      green: {
        green47: '#23CC6B',
        green37: '#568B30',
        green32: '#00A200',
        green26: '#008300',
        green20: '#006601',
        green13: '#004201',
        light: '#00A200',
        default: '#008300',
        dark: '#006601',
        darker: '#004201',
      },
      blue: {
        blue53: '#366Cd9',
        default: '#366Cd9',
      },
      purple: {
        purple37: '#502D91',
        purple32: '#551A8B',
        purple15: '#241239',
      },
      yellow: {
        yellow52: '#Fde30b',
        yellow50: '#ffd700',
        default: '#Fde30b',
      },
      taupe: {
        taupe90: '#f7edd2',
        taupe73: '#ead18b',
      },
      gold: {
        gold67: '#f7da5e',
        gold50: '#FFCC00',
      },
      ivory: {
        ivory84: '#ffe0ae',
      },
      olive: {
        olive66: '#d7e26d',
      },
      teal: {
        teal95: '#edf8f7',
        teal81: '#bae2e0',
        teal76: '#a7dbd8',
        teal27: '#038767',
      },
      coral: {
        coral72: '#f99178',
      },
      lime: {
        lime70: '#BAE582',
      },
      oatmeal: {
        oatmeal: '#F7F4EA',
      },
    },
    background: {
      default: '#fff',
      lightest: '#f7f7f7',
      darkest: '#333',
      ribbon: '#fff',
      disabled: '#f7f7f7',
      warning: '#FFF5EB',
    },
    text: {
      formLabel: '#666',
      onLight: {
        primary: '#333',
        secondary: '#666',
      },
      onDark: {
        primary: '#fff',
      },
    },
    iconFill: {
      onLight: '#888',
    },
    link: {
      default: '#366Cd9',
      visited: '#551A8B',
      onLight: {
        default: '#666',
        hover: '#333',
        focus: '#333',
      },
      onLightSecondary: {
        default: '#333',
        hover: '#000',
      },
      onDark: {
        default: '#fff',
        hover: '#d6d6d6',
      },
      promotion: {
        default: '#c00',
        hover: '#a00',
      },
      success: {
        default: '#008300',
        hover: '#00A200',
      },
      warning: {
        default: '#E86900',
        hover: '#b85300',
      },
      defaultColor: {
        default: '#366Cd9',
        hover: '#366Cd9',
      },
    },
    interactive: {
      primary: {
        default: '#c00',
        hover: '#a00',
        active: '#790000',
      },
      secondary: {
        default: '#fff',
        hover: '#f7f7f7',
        active: '#333',
      },
      disabled: {
        default: '#d6d6d6',
      },
      native: {
        flatButton: '#366Cd9',
      },
    },
    border: {
      focusOutline: '#888',
      activeSelection: '#c00',
      interactive: {
        secondary: {
          default: '#888',
          hover: '#333',
        },
      },
      control: {
        input: '#888',
        secondary: '#888',
      },
      container: {
        default: '#d6d6d6',
        active: '#888',
      },
      separator: {
        default: '#d6d6d6',
        row: '#d6d6d6',
      },
      disabled: '#d6d6d6',
      warning: '#E86900',
      success: '#008300',
    },
    alert: {
      warning: '#b85300',
      success: '#008300',
    },
    messaging: {
      urgency: '#008300',
      progress: '#008300',
      shipping: '#b85300',
      inStock: '#008300',
      limitedStock: '#b85300',
      promotion: '#c00',
      clearance: '#ffd700',
      delivered: '#000',
      canceled: '#000',
      returned: '#000',
      sent: '#000',
      pickedup: '#000',
      actionRequired: '#b85300',
      disabled: '#666',
      warning: '#b85300',
      success: '#008300',
    },
    registry: {
      promoBackground: '#ead18b',
      noteBackground: '#ead18b',
      mostWanted: '#f7da5e',
      baby: '#d7e26d',
      wedding: '#a7dbd8',
      college: '#f7da5e',
      housewarming: '#f7da5e',
      wishlist: '#568B30',
      custom: '#a7dbd8',
      background: {
        baby: {
          primary: '#bae2e0',
          secondary: '#edf8f7',
        },
        wedding: {
          primary: '#ead18b',
          secondary: '#f7edd2',
        },
      },
    },
    circle: {
      brand: {
        primary: '#c00',
        secondary: '#fff',
      },
      background: {
        primary: '#720000',
        secondary: '#e8e8e8',
      },
      text: {
        primary: '#333',
        secondary: '#666',
      },
    },
    shipt: {
      brand: {
        green: '#23CC6B',
        purple: '#241239',
      },
      teal: '#038767',
      lime: '#BAE582',
      purple: '#502D91',
      gold: '#FFCC00',
      oatmeal: '#F7F4EA',
    },
  },
  font: {
    family: {
      sansSerif:
        '"Helvetica for Target", "HelveticaForTarget", "Targetica", "HelveticaNeue for Target", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
    },
    size: {
      text: {
        xsmall: '10px',
        small: '12px',
        medium: '14px',
        base: '16px',
        large: '19px',
        xlarge: '23px',
        xxlarge: '29px',
      },
      input: {
        base: '16px',
      },
      body: {
        small: '12px',
        medium: '14px',
        large: '16px',
      },
      heading: {
        level1: '29px',
        level2: '23px',
        level3: '19px',
        level4: '16px',
        level5: '14px',
      },
    },
    weight: {
      light: 300,
      normal: 400,
      bold: 'bold',
      input: {
        text: 400,
      },
    },
    lineHeight: {
      text: 1.4285,
      heading: 1.25,
      input: 1.25,
      reset: 1,
    },
  },
  height: {
    button: {
      sm: '32px',
      md: '44px',
      lg: '56px',
      kiosk: '56px',
    },
  },
  layering: {
    overlay: {
      modal: 'rgba(51,51,51,0.8)',
    },
  },
  shadow: {
    low: {
      onLight:
        '0px -1px 2px rgba(0,0,0,0.04), 0px 1px 2px rgba(0,0,0,0.04), 0px 3px 4px rgba(0,0,0,0.04);',
      onDark:
        '0px -1px 2px rgba(0,0,0,0.06), 0px 1px 2px rgba(0,0,0,0.06), 0px 3px 4px rgba(0,0,0,0.06);',
    },
    medium: {
      onLight:
        '0px -1px 6px rgba(0,0,0,0.02), 0px 1px 3px rgba(0,0,0,0.04), 0px 3px 5px rgba(0,0,0,0.06), 0 4px 6px rgba(0,0,0,0.04);',
      onDark:
        '0px -1px 6px rgba(0,0,0,0.04), 0px 1px 3px rgba(0,0,0,0.06), 0px 3px 5px rgba(0,0,0,0.08), 0 4px 6px rgba(0,0,0,0.06);',
    },
    high: {
      onLight:
        '0px 2px 4px rgba(0,0,0,0.04), 0px 2px 8px rgba(0,0,0,0.04), 0px 4px 10px rgba(0,0,0,0.06), 0 6px 12px rgba(0,0,0,0.04);',
      onDark:
        '0px 2px 4px rgba(0,0,0,0.06), 0px 2px 8px rgba(0,0,0,0.06), 0px 4px 10px rgba(0,0,0,0.08), 0 6px 12px rgba(0,0,0,0.06);',
    },
  },
  space: {
    generic: {
      x1: '4px',
      x2: '8px',
      x3: '12px',
      x4: '16px',
      x5: '20px',
      x6: '24px',
      x7: '28px',
      x8: '32px',
      x9: '36px',
      x10: '40px',
      x11: '44px',
    },
    inset: {
      x1: '4px',
      x2: '8px',
      x3: '12px',
      x4: '16px',
      x5: '20px',
      x6: '24px',
      x7: '28px',
      x8: '32px',
      x9: '36px',
      x10: '40px',
      x11: '44px',
    },
    insetSquish: {
      x1: '4px 8px',
      x2: '12px 16px',
      x3: '12px 20px',
      x4: '16px 24px',
      x5: '20px 32px',
      x6: '20px 36px',
    },
    stack: {
      x1: '0 0 4px',
      x2: '0 0 8px',
      x3: '0 0 12px',
      x4: '0 0 16px',
      x5: '0 0 20px',
      x6: '0 0 24px',
      x7: '0 0 32px',
      x8: '0 0 36px',
      x9: '0 0 40px',
      x10: '0 0 44px',
    },
  },
};
